module["exports"] = [
  "Pvt Ltd",
  "Group",
  "Ltd",
  "Limited"
];
